import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useContext } from "react";
import Home from "./pages/Home/Home";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import AboutUrologist from "./components/AboutUrologist/AboutUrologist";
import Contact from "./pages/Contact/Contact";
import Login from "./pages/Login/Login";
import FloatingContact from "./components/FloatingContact/FloatingContact";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import DashboardHome from "./pages/Dashboard/DashboardHome";
import UserProfile from "./pages/Dashboard/UserProfile";
import Blogs from "./pages/Dashboard/Blogs";
import Settings from "./pages/Dashboard/Settings";
import CreateBlog from "./pages/Dashboard/CreateBlog";
import PublicBlogs from "./pages/PublicBlogs/PublicBlogs";
import BlogDetail from "./pages/BlogDetail/BlogDetail";
import { AuthContext } from "./context/AuthContext";
import Feedback from "./pages/Feedback/Feedback";

function AppContent() {
  const location = useLocation();
  const { isLoggedIn } = useContext(AuthContext);
  
  // Check if current route is a dashboard route
  const isDashboardRoute = location.pathname.startsWith("/dashboard");

  return (
    <>
      {!isDashboardRoute && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUrologist />} />
        <Route path="/treatments" element={<h1>Treatments</h1>} />
        <Route path="/appointment" element={<h1>Book Appointment</h1>} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
         <Route path="/feedback" element={<Feedback />} />

        {/* Public Blog Routes */}
        <Route path="/blogs" element={<PublicBlogs />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />

        {/* Dashboard Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/profile"
          element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/blogs"
          element={
            <ProtectedRoute>
              <Blogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/create-blog"
          element={
            <ProtectedRoute>
              <CreateBlog />
            </ProtectedRoute>
          }
        />
      </Routes>

      {!isDashboardRoute && <Footer />}
      {!isDashboardRoute && <FloatingContact />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;